export * from './offers-carousel';
